var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20,1c10.49,0,19,8.51,19,19s-8.51,19-19,19S1,30.49,1,20,9.51,1,20,1m0-1C8.95,0,0,8.95,0,20s8.95,20,20,20,20-8.95,20-20S31.05,0,20,0Z",
    fill: "#eaeaea",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.89,20.06c2.38-3.31,4-7.2,4.6-11.44.12-.87-.43-1.71-1.29-1.93l-4.43-1.14c-.82-.2-1.68.21-2.02.98l-2.32,5.23c-.32.71-.11,1.55.5,2.05l2.55,2.04c-1.86,3.16-4.48,5.79-7.64,7.64l-2.04-2.55v-.02c-.5-.61-1.34-.82-2.05-.5l-5.23,2.32c-.77.34-1.18,1.2-.96,2.02l1.14,4.43c.23.86,1.05,1.41,1.93,1.29,4.02-.56,7.73-2.07,10.93-4.26.54-3.2,3.1-5.7,6.33-6.16Z",
    fill: "#444",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.94,26.73v1.5c0,.21-.17.38-.38.38h-1.27c-.11.41-.27.8-.48,1.15l.9.9c.15.15.15.38,0,.53l-1.06,1.06c-.15.15-.38.15-.53,0l-.9-.9c-.36.21-.74.38-1.15.48v1.27c0,.21-.17.38-.38.38h-1.5c-.21,0-.38-.17-.38-.38v-1.27c-.41-.11-.8-.27-1.15-.48l-.9.9c-.15.15-.38.15-.53,0l-1.06-1.06c-.15-.15-.15-.38,0-.53l.9-.9c-.21-.36-.38-.74-.48-1.15h-1.28c-.21,0-.38-.17-.38-.38v-1.5c0-.21.16-.38.38-.38h1.28c.1-.41.27-.8.48-1.15l-.9-.9c-.15-.15-.15-.38,0-.53l1.06-1.06c.15-.15.38-.15.53,0l.9.9c.36-.21.74-.38,1.15-.48v-1.28c0-.21.16-.38.38-.38h1.5c.21,0,.38.16.38.38v1.28c.41.1.8.27,1.15.48l.9-.9c.15-.15.38-.15.53,0l1.06,1.06c.15.15.15.38,0,.53l-.9.9c.21.36.38.74.48,1.15h1.27c.21,0,.38.16.38.38Zm-7.59-.84c-.88.88-.88,2.3,0,3.18s2.3.88,3.18,0,.88-2.3,0-3.18-2.3-.88-3.18,0Z",
    fill: "#ef5323",
    strokeWidth: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSettings);
export default __webpack_public_path__ + "static/media/phone_settings.86a606db970c6519e97b8715002e1666.svg";
export { ForwardRef as ReactComponent };